// extracted by mini-css-extract-plugin
export default {"initials":"UserInitials_initials__-p5Oq"};